import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';

const AR_ORDINALS = [
  'أولاً',
  'ثانياً',
  'ثالثاً',
  'رابعاً',
  'خامساً',
  'سادساً',
  'سابعاً',
  'ثامناً',
  'تاسعاً',
  'عاشراً',
  'الحادي عشر',
  'الثاني عشر',
  'الثالث عشر',
  'الرابع عشر',
  'الخامس عشر',
  'السادس عشر',
  'السابع عشر',
  'الثامن عشر',
  'التاسع عشر',
  'العشرون',
] as const;

const EN_SUFFIXES = ['th', 'st', 'nd', 'rd'] as const;
const NO_GROUPING = { useGrouping: false } as const;

/** Formats a positive integer as a locale-aware ordinal for the app's supported languages. */
@Pipe({ name: 'ordinal', standalone: true, pure: false })
export class OrdinalPipe implements PipeTransform {
  readonly #locale = inject(TranslocoLocaleService);

  transform(n: number): string {
    const locale = this.#locale.getLocale();
    const lang = locale.split('-')[0].toLowerCase();
    const formatted = this.#locale.localizeNumber(n, 'decimal', locale, NO_GROUPING);

    switch (lang) {
      case 'ar':
        return AR_ORDINALS[n - 1] ?? formatted;
      case 'da':
        return `${formatted}.`;
      case 'fr':
        return `${formatted}${n === 1 ? 'er' : 'e'}`;
      case 'en': {
        const mod100 = n % 100;
        const suffix = mod100 > 3 && mod100 < 21 ? 'th' : EN_SUFFIXES[n % 10] ?? 'th';
        return `${formatted}${suffix}`;
      }
      default:
        return formatted;
    }
  }
}
